module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product24-98747a6038313641f5578b6b89631eee.jpg";